// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/infographic-page-landscape/infographic-page-landscape.component.scss
// module id = 390
// module chunks = 0